// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__2nb7Z","Header":"Home_Header__iBkRe","Start":"Home_Start__3nuVF"};